import { SIZES } from "../theme/constant";



const LOGO ={
    warpper:{
        marginTop:SIZES.large*4
    }
}

const TEXT ={
    heading1:{
        marginTop:SIZES.large*2,
        fontSize:SIZES.xLarge*2.5,
        marginBottom:0
    },
    heading4:{
        fontSize:SIZES.small,
        fontWeight:400,
        
    }
}

const BUTTON = {
    primary:{
        // paddingTop:SIZES.large,
        height:'48px',
        paddingLeft:SIZES.xxLarge*2,
        paddingRight:SIZES.xxLarge*2,
    },
    default:{
        // paddingTop:SIZES.large,
        height:'48px',
        paddingLeft:SIZES.xxLarge*2,
        paddingRight:SIZES.xxLarge*2,
    }
}

const HEROIMG ={
    IMG:{
        height:'100%',
        marginTop:SIZES.large*2,
    },
    WRAPPER:{
        marginTop:SIZES.xxLarge,
        height:250
    }
}


export {LOGO, TEXT, BUTTON, HEROIMG}